import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";

class authorizationModalParnter extends Component{
    constructor(props) {
        super(props);
        this.state = {
            invalidComment: false,
        };
    }

    closeModal = async () => {
        $("#authorizationModalParnter").modal("hide");  
    }

    ValidateComments = async (event, index) => {
        const {updateComments} = this.props;
        updateComments(event, index);

        let invalidComment = false;
        if (event.nativeEvent.target.value.length > 50) { invalidComment = true; }
        await this.setState({ invalidComment });
    }
  
    Continue = () => {
        const { authModels, continueAction, notificationReducer: { showAlert } } = this.props;
        const {invalidComment} = this.state;

        let { model } = this.props;

        if (invalidComment) {
            return showAlert({ type: "error", message: "Ingrese un comentario valido, no mayor a 50 caracteres", timeOut: 5000 });
        }

        model.isAuth = true;
        model.authComments = authModels.map((authModel) => authModel.comment).join(", ");
        continueAction(model);
        $("#authorizationModalParnter").modal("hide");  
    }

    
    render() {
        const {authModels} = this.props;
        const {invalidComment} = this.state;

        return (
                <div className="modal" tabIndex="-1" role="dialog" id="authorizationModalParnter" >
                    <div className="modal-dialog" >
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"> Modelo de autorización </h5>
                            <button type="button" className="close"  onClick={this.closeModal}  aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p> Este proceso requiere la autorización de otros usuarios. </p>
                            <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active "aria-labelledby="nav-home-tab-Contenido" style={{marginBottom: 0, minheight: 450, maxHeight: 570}}>
                                            <table className="table response" style={{marginBottom: 0}}>
                                                <tbody>
                                                    <tr>
                                                        <td className="sticky-header table-header-yellow "> Modelo de autorización </td>
                                                        <td className="sticky-header table-header-yellow "> Comentarios </td>
                                                    </tr>
                                                    {authModels.map((model, index) =>
                                                        <tr>
                                                            <td>
                                                                <label className="font-weight-bold" id="userField1">{model.name}</label>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className={`form-control form__input ${invalidComment? "form__group-incorrect" : ""}`}
                                                                    type="text" 
                                                                    onChange = {(event) => this.ValidateComments(event, index)}
                                                                    value = {model.comment  || ""}
                                                                    />
                                                                {invalidComment &&
                                                                    <span className="form__input-error-active" style={{fontSize: 14, whiteSpace: "pre-line"}}>El comentario no debe ser mayor a 50 caracteres</span>}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.Continue}> Ok </button>
                            <button type="button" className="btn botonCorrect text-black" onClick={this.closeModal}>Cancelar</button>
                        </div>
                        </div>
                    </div>
                </div>
        );  
    }
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer
    };
};

export default connect(mapStateToProps)(authorizationModalParnter);